import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ spacing }) => ({
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    gridRowGap: spacing(1),
    maxHeight: 30,
    overflow: "hidden",
  },
}));
